export const DESIGNER = {
	KBC: "cvs_kbc",
	AXIS: "cvs_axis",
	METAL: "cvs_metal",
	METAL_LITE: "cvs_metal_lite",
	G_FIRST: "cvs_gfirst"
};

export const LAYER_CATEGORY_ID = {
	card: 1,
	logo: 2,
	text: 7, //3,
	doodle: 9,
	signature: 11
};

// This is synced with database table columns
export const CUSTOM_IMAGE_TYPE_ID = {
	image: 1,
	logo: 2,
	flickr: 3,
	facebook: 5,
	monogram: 6,
	text: 7,
	clipArt: 8,
	doodle: 9,
	overlay: 10,
	signature: 11,
	textasimage: 12
};


export const LAYER_TYPE = {
	CARD: 'card',
	TEXT: 'text',
	LOGO: 'Logo',
	DOODLE: 'doodle',
	SIGNATURE: 'signature',
	OVERLAY: 'overlay',
	MONOGRAM: 'monogram'
};


export const SPECIAL_EFFECTS_INTENSITY = {
	OFF: 0,
	LOW: 1,
	MEDIUM: 2,
	HIGH: 3
};

export const IMAGE_TYPE = {
	STOCK: 1,
	LOGO: 2,
	TEXT: 7,
	DOODLE: 9,
	SIGNATURE:11
};

export const ERROR_TYPE = {
	LOCKED:'locked',
	COVERAGE_CARD:'card-coverage'
};

export const DIRECTORY = {
	CDN: 'PCS/CDN/',
	APP: 'PCS/CDN/V3/App/',
	SHARED_ASSETS: 'PCS/CDN/V3/App/Skins/SharedAssets/',
};

export const environments = {
	uk: {
		'apiurl': 'https://uk.personalcard.net/pcs/api/v3',
		'cdnurl': 'https://uk.personalcard.net/pcs/cdn/V3/App/Skins/',
		'apitrackerurl': 'https://uk.personalcard.net/apitracker'
	},
	us: {
		'apiurl': 'https://us.personalcard.net/pcs/api/v3',
		'cdnurl': 'https://us.personalcard.net/pcs/cdn/V3/App/Skins/',
		'apitrackerurl': 'https://us.personalcard.net/apitracker'
	},
	syd: {
		'apiurl': 'https://au.personalcard.net/api/v3',
		'cdnurl': 'https://au.personalcard.net/pcs/cdn/V3/App/Skins/',
		'apitrackerurl': 'https://au.personalcard.net/apitracker'
	},
	sta: {
		'apiurl': 'https://staging.serversidegraphics.com/pcs/api/v3',
		'cdnurl': 'https://staging.serversidegraphics.com/pcs/cdn/V3/App/Skins/',
		'apitrackerurl': 'https://staging.serversidegraphics.com/apitracker'
	},
	axisprod: {
		'apiurl': 'https://axisbank.personalcard.net/api/v3',
		'cdnurl': 'https://au.personalcard.net/pcs/cdn/V3/App/Skins/',
		'apitrackerurl': 'https://au.personalcard.net/apitracker'
	},
	axisuat: {
		'apiurl': 'https://axisbankuat.serversidegraphics.com/pcs/api/v3',
		'cdnurl': 'https://uat.serversidegraphics.com/pcs/cdn/V3/App/Skins/',
		'apitrackerurl': 'https://uat.serversidegraphics.com/apitracker'
	},
	uat: {
		'apiurl': 'https://uat.serversidegraphics.com/pcs/api/v3',
		'cdnurl': 'https://uat.serversidegraphics.com/pcs/cdn/V3/App/Skins/',
		'apitrackerurl': 'https://uat.serversidegraphics.com/apitracker'
	},
	dev: {
		'apiurl': 'https://devserver.serversidegraphics.com/pcs/api/v3',
		'cdnurl': 'https://devserver.serversidegraphics.com/pcs/cdn/V3/App/Skins/',
		'apitrackerurl': 'https://devserver.serversidegraphics.com/apitracker'
	},
	default: {
		'apiurl': 'https://localhost/pcs/api/v3',
		'cdnurl': 'https://localhost/PCS/CDN/V3/App/Skins/',
		'apitrackerurl': 'https://localhost/apitracker'
	}
};

export const COLOUR_RANGE = [
	'#600f0f','#830000','#c60000','#ff0000', '#f70ff0','#ff4fef','#ff6347','#ff6060','#fa8072', '#ff9393', '#ffa500', '#ffa3ec','#ff90ff',
	'#e37fff','#ffc0cb', '#ffff00', '#ffffff', '#98fb98', '#00ffff', '#00ffff','#008080','#0000ff','#4200ff', '#6800ff','#9322ff','#bc21ff',
	'#800080', '#e1e1eb','#a5a5a5','#636363','#383838','#000000'  
];

export const BLEED_AREA = {
	width: 4,
	height: 4
}
